function toNumber(value) {
  const n = parseFloat(String(value ?? '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}

/** Mensaje cuando hay gastos mensuales pero faltan unidades estimadas. */
export const UNIDADES_AYUDA_MSG =
  'Los gastos cargados son mensuales. Para distribuirlos correctamente indicá una estimación de unidades vendidas o producidas por mes.';

export function parseUnidadesMensuales(raw) {
  if (raw === null || raw === undefined || raw === '') return null;
  const n = parseFloat(String(raw).replace(',', '.'));
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}

export function getPricingSuggestionDefaults() {
  return {
    alquilerMensual: 0,
    movilMensual: 0,
    combustibleMensual: 0,
    otrosGastosMensuales: 0,
    unidadesMensualesEstimadas: '',
    margenObjetivoPct: 30
  };
}

/**
 * Precio sugerido = (costo + gastos_mensuales/unidades) / (1 - margen%).
 * Si no hay unidades válidas, NO se prorratean gastos fijos (evita precios absurdos).
 */
export function computeSuggestedPrice({
  costoUnitario,
  alquilerMensual,
  movilMensual,
  combustibleMensual,
  otrosGastosMensuales,
  unidadesMensualesEstimadas,
  margenObjetivoPct
}) {
  const costo = Math.max(0, toNumber(costoUnitario));
  const unidades = parseUnidadesMensuales(unidadesMensualesEstimadas);
  const margenRaw = toNumber(margenObjetivoPct);
  const margen = Math.min(95, Math.max(0, margenRaw));
  const gastosMensuales =
    Math.max(0, toNumber(alquilerMensual)) +
    Math.max(0, toNumber(movilMensual)) +
    Math.max(0, toNumber(combustibleMensual)) +
    Math.max(0, toNumber(otrosGastosMensuales));

  const gastoPorUnidad = unidades != null && gastosMensuales > 0 ? gastosMensuales / unidades : 0;
  const costoTotalUnitario = costo + gastoPorUnidad;
  const denominator = 1 - margen / 100;
  const suggestedPrice = denominator > 0 ? costoTotalUnitario / denominator : 0;

  return {
    costoUnitario: costo,
    gastosMensuales,
    unidadesMensualesEstimadas: unidades,
    margenObjetivoPct: margen,
    gastoPorUnidad,
    costoTotalUnitario,
    suggestedPrice,
    incluyeGastosFijos: unidades != null && gastosMensuales > 0,
    canSuggest: costo > 0 && denominator > 0,
    warnings: {
      margenAjustado: margen !== margenRaw,
      unidadesRequeridasParaGastos: gastosMensuales > 0 && unidades == null,
      unidadesInvalidas: unidadesMensualesEstimadas !== '' && unidades == null
    }
  };
}
